import { differenceInDays, differenceInHours, differenceInMinutes } from "date-fns";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { FileQuestionIcon } from "../../../../assets/icons";
import { EmployeeCompanyPoliciesSummaryDTO } from "../../../../models/employee-company-policies-summary/employee-company-policies-summary-dto";
import IconAndTitleContainer from "../../reusable-widget-link-components/IconAndTitleContainer/IconAndTitleContainer";

const MyPoliciesLink = ({
  customSummary,
  loading,
}: {
  customSummary: EmployeeCompanyPoliciesSummaryDTO;
  loading: boolean;
}) => {
  const tRP = "components.custom_widget_links.my_policies";
  const { t } = useTranslation();

  const calculatePassingTime = useCallback((): string | undefined => {
    if (customSummary?.latestUnreviewedPolicy) {
      const sinceDays = Math.abs(differenceInDays(new Date(customSummary.latestUnreviewedPolicy), new Date()));
      const sinceHours = Math.abs(
        differenceInHours(
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate(),
            new Date(customSummary.latestUnreviewedPolicy).getHours()
          ),
          new Date()
        )
      );

      const sinceMinutes = Math.abs(
        differenceInMinutes(
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate(),
            new Date().getHours(),
            new Date(customSummary.latestUnreviewedPolicy).getMinutes()
          ),
          new Date()
        )
      );

      return `${sinceDays} days, ${sinceHours} hours, ${sinceMinutes} minutes`;
    }

    return;
  }, [customSummary]);

  return (
    <>
      <IconAndTitleContainer
        title={`${customSummary?.pendingReviewPolicies} ${t(`${tRP}.unreviewed`)}`}
        description={calculatePassingTime()}
        Icon={FileQuestionIcon}
        loading={loading}
      />
    </>
  );
};

export default MyPoliciesLink;
